/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @flow
 */

/**
 * Attribution methods.
 */

const AttributionMethod = Object.freeze({
    ARD : 'ard',
    DEEPLINK : 'deeplink',
    GPIR : 'gpir',
    INVALID_RESPONSE : 'invalid_response',
    MIR : 'mir',
    SRN : 'srn'
});

export default AttributionMethod;
